import {
  ActivitySnapshot,
  ActivitySnapshotEntry,
} from "@api/graphql/generated/generated-types";

export interface SnapshotDiffEntry {
  key: string;
  oldValue?: string;
  newValue?: string;
  changed: boolean;
}

function entriesToMap(
  entries?: (ActivitySnapshotEntry | null)[] | null
): Record<string, string> {
  const map: Record<string, string> = {};
  if (!entries) return map;
  entries.forEach((entry) => {
    if (entry && entry.key) map[entry.key] = entry.value ?? "";
  });
  return map;
}

export function diffSnapshotEntries(
  oldSnap?: ActivitySnapshot | null,
  newSnap?: ActivitySnapshot | null
): SnapshotDiffEntry[] {
  const oldMap = entriesToMap(oldSnap?.entries);
  const newMap = entriesToMap(newSnap?.entries);
  const allKeys = Array.from(
    new Set([...Object.keys(oldMap), ...Object.keys(newMap)])
  );
  return allKeys.map((key) => {
    const oldValue = oldMap[key];
    const newValue = newMap[key];
    return {
      key,
      oldValue,
      newValue,
      changed: oldValue !== newValue,
    };
  });
}
